import React from "react";

const Resume = () => {
  return <div>Resume Resume</div>;
};

export default Resume;
